export const getPattern = (includeProtocol: boolean): string => {
  let pattern = ''
  switch (globalThis.location.host) {
    case 'teams-integration.blue-sciforma.net':
      pattern = `[\\w\\W\\-]*\.blue-sciforma\.net$`
      break
    case 'teams-integration.white-sciforma.net':
      pattern = `[\\w\\W\\-]*\.white-sciforma\.net$`
      break
    case 'teams-integration.sciforma.net':
      pattern = `[\\w\\W\\-]*\.sciforma\.net$`
      break
    default:
      return `[\\w\\W\\-]`
  }
  return includeProtocol ? `https:\\/\\/${pattern}` : pattern
}

export const getPlaceholder = (includeProtocol: boolean): string => {
  let placeholder = ''
  switch (globalThis.location.host) {
    case 'teams-integration.blue-sciforma.net':
      placeholder = 'example.blue-sciforma.net'
      break
    case 'teams-integration.white-sciforma.net':
      placeholder = 'example.white-sciforma.net'
      break
    case 'teams-integration.sciforma.net':
      placeholder = 'example.sciforma.net'
      break
    default:
      return 'https://example.sciforma.net'
  }
  return includeProtocol ? `https://${placeholder}` : placeholder
}
